export const FieldTypes = {
  ShortText: 'short_text',
  FreeText: 'long_text',
  // Number: 'number',
  Email: 'email',
  Website: 'website',
  MultipleChoice: 'multiple_choice',
  YesNo: 'yes_no',
  Select: 'select',
  MultiSelect: 'multi_select',
  OpinionScale: 'opinion_scale',
  Date: 'date',
  DateSelector: 'date_selector',
  Address: 'address',
  PhoneNumber: 'phone_number',
  StarRating: 'rating',
  Upload: 'file_upload',
  DocumentUpload: 'upload',
  IdRequirementsWrapper: 'id_requirements',
  Download: 'download',
  ReadOnly: 'read_only',
  Statement: 'statement',
  Signature: 'signature',
  Country: 'country',
  Text: 'text',
  IdRequirementsList: 'id_requirements_list',
  Checkbox: 'checkbox',
  DynamicArray: 'dynamic_array',
  FixedArray: 'array',
  Consent: 'consent',
  Hidden: 'hidden',
  PDFPreview: 'pdf_preview',
};

export const FieldTypeDetails = {
  [FieldTypes.ShortText]: {
    title: 'Free Text',
    subTitle: 'Answer freely with unlimited text answers',
  },
  [FieldTypes.FreeText]: {
    title: 'Free Text',
    subTitle: 'Answer freely with unlimited text answers',
  },
  [FieldTypes.MultipleChoice]: {
    title: 'Multi-Choice',
    subTitle: 'Select single or multiple answers, or add optional free text',
  },
  [FieldTypes.YesNo]: {
    title: 'Yes/No',
    subTitle: 'Simple yes or No answer',
  },
  [FieldTypes.OpinionScale]: {
    title: 'Opinion Scale',
    subTitle: 'Create your own scales, NPS scoring, or ratings system',
  },
  [FieldTypes.Date]: {
    title: 'Date',
    subTitle: 'Request a specific date (eg preferred start date)',
  },
  [FieldTypes.DateSelector]: {
    title: 'Date Selector',
    subTitle: 'Select date using dropdown selectors',
  },
  [FieldTypes.PhoneNumber]: {
    title: 'Phone Number',
    subTitle: 'Request specific phone number',
  },
  [FieldTypes.StarRating]: {
    title: 'Star Rating',
    subTitle: 'Create your own rating scales',
  },
  [FieldTypes.Upload]: {
    title: 'Upload',
    subTitle: 'Easily upload your docs / ID etc. Use your camera if on a phone',
  },
  [FieldTypes.Statement]: {
    title: 'Statement',
    subTitle: 'A basic statement that does not require an answer',
  },
  [FieldTypes.Signature]: {
    title: 'Signature',
    subTitle: 'A simple signature block to confirm understanding',
  },
  [FieldTypes.Country]: {
    title: 'Country Selector',
    subTitle: 'Country list',
  },
  [FieldTypes.Checkbox]: {
    title: 'Checkbox',
    subTitle: 'A simple checkbox to confirm understanding',
  },
  [FieldTypes.Select]: {
    title: 'Select',
    subTitle: 'A simple select dropdown',
  },
  [FieldTypes.Address]: {
    title: 'Address',
    subTitle: 'A simple address block',
  },
  [FieldTypes.DynamicArray]: {
    title: 'Dynamic Array',
    subTitle: 'A dynamic array of fields',
  },
  [FieldTypes.FixedArray]: {
    title: 'Fixed Array',
    subTitle: 'A fixed-size array of fields',
  },
  [FieldTypes.IdRequirementsList]: {
    title: 'ID Requirements List',
    subTitle: 'A list of ID requirements',
  },
  [FieldTypes.Email]: {
    title: 'Email',
    subTitle: 'A simple email block',
  },
  [FieldTypes.Website]: {
    title: 'Website',
    subTitle: 'A simple website block',
  },
  [FieldTypes.DocumentUpload]: {
    title: 'Upload File',
    subTitle: 'A simple upload file block',
  },
  [FieldTypes.Download]: {
    title: 'Download',
    subTitle: 'A simple download block',
  },
  [FieldTypes.ReadOnly]: {
    title: 'Read Only',
    subTitle: 'A simple read only block',
  },
  [FieldTypes.MultiSelect]: {
    title: 'Multi Select',
    subTitle: 'A multi select dropdown',
  },
  [FieldTypes.PDFPreview]: {
    title: 'PDF Preview',
    subTitle: 'A simple pdf preview block',
  },
};

export const FieldTypesOptions = [
  {
    title: FieldTypeDetails[FieldTypes.FreeText].title,
    subTitle: FieldTypeDetails[FieldTypes.FreeText].subTitle,
    key: FieldTypes.FreeText,
  },
  {
    title: FieldTypeDetails[FieldTypes.Email].title,
    subTitle: FieldTypeDetails[FieldTypes.Email].subTitle,
    key: FieldTypes.Email,
  },
  {
    title: FieldTypeDetails[FieldTypes.MultipleChoice].title,
    subTitle: FieldTypeDetails[FieldTypes.MultipleChoice].subTitle,
    key: FieldTypes.MultipleChoice,
  },
  {
    title: FieldTypeDetails[FieldTypes.YesNo].title,
    subTitle: FieldTypeDetails[FieldTypes.YesNo].subTitle,
    key: FieldTypes.YesNo,
  },
  {
    title: FieldTypeDetails[FieldTypes.OpinionScale].title,
    subTitle: FieldTypeDetails[FieldTypes.OpinionScale].subTitle,
    key: FieldTypes.OpinionScale,
  },
  {
    title: FieldTypeDetails[FieldTypes.Date].title,
    subTitle: FieldTypeDetails[FieldTypes.Date].subTitle,
    key: FieldTypes.Date,
  },
  {
    title: FieldTypeDetails[FieldTypes.PhoneNumber].title,
    subTitle: FieldTypeDetails[FieldTypes.PhoneNumber].subTitle,
    key: FieldTypes.PhoneNumber,
  },
  {
    title: FieldTypeDetails[FieldTypes.StarRating].title,
    subTitle: FieldTypeDetails[FieldTypes.StarRating].subTitle,
    key: FieldTypes.StarRating,
  },
  {
    title: FieldTypeDetails[FieldTypes.Upload].title,
    subTitle: FieldTypeDetails[FieldTypes.Upload].subTitle,
    key: FieldTypes.Upload,
  },
  {
    title: FieldTypeDetails[FieldTypes.Statement].title,
    subTitle: FieldTypeDetails[FieldTypes.Statement].subTitle,
    key: FieldTypes.Statement,
  },
  {
    title: FieldTypeDetails[FieldTypes.Signature].title,
    subTitle: FieldTypeDetails[FieldTypes.Signature].subTitle,
    key: FieldTypes.Signature,
  },
  {
    title: FieldTypeDetails[FieldTypes.Country].title,
    subTitle: FieldTypeDetails[FieldTypes.Country].subTitle,
    key: FieldTypes.Country,
  },
  {
    title: FieldTypeDetails[FieldTypes.Checkbox].title,
    subTitle: FieldTypeDetails[FieldTypes.Checkbox].subTitle,
    key: FieldTypes.Checkbox,
  },
];

export const TypeformFieldTypesOptions = [
  {
    title: FieldTypeDetails[FieldTypes.FreeText].title,
    subTitle: FieldTypeDetails[FieldTypes.FreeText].subTitle,
    key: FieldTypes.FreeText,
  },
  {
    title: FieldTypeDetails[FieldTypes.MultipleChoice].title,
    subTitle: FieldTypeDetails[FieldTypes.MultipleChoice].subTitle,
    key: FieldTypes.MultipleChoice,
  },
  {
    title: FieldTypeDetails[FieldTypes.YesNo].title,
    subTitle: FieldTypeDetails[FieldTypes.YesNo].subTitle,
    key: FieldTypes.YesNo,
  },
  {
    title: FieldTypeDetails[FieldTypes.OpinionScale].title,
    subTitle: FieldTypeDetails[FieldTypes.OpinionScale].subTitle,
    key: FieldTypes.OpinionScale,
  },
  {
    title: FieldTypeDetails[FieldTypes.Date].title,
    subTitle: FieldTypeDetails[FieldTypes.Date].subTitle,
    key: FieldTypes.Date,
  },
  {
    title: FieldTypeDetails[FieldTypes.PhoneNumber].title,
    subTitle: FieldTypeDetails[FieldTypes.PhoneNumber].subTitle,
    key: FieldTypes.PhoneNumber,
  },
  {
    title: FieldTypeDetails[FieldTypes.Statement].title,
    subTitle: FieldTypeDetails[FieldTypes.Statement].subTitle,
    key: FieldTypes.Statement,
  },
];

export const CustomFieldTypesOptions = [
  {
    title: FieldTypeDetails[FieldTypes.FreeText].title,
    subTitle: FieldTypeDetails[FieldTypes.FreeText].subTitle,
    key: FieldTypes.FreeText,
  },
  {
    title: FieldTypeDetails[FieldTypes.MultipleChoice].title,
    subTitle: FieldTypeDetails[FieldTypes.MultipleChoice].subTitle,
    key: FieldTypes.MultipleChoice,
  },
  {
    title: FieldTypeDetails[FieldTypes.YesNo].title,
    subTitle: FieldTypeDetails[FieldTypes.YesNo].subTitle,
    key: FieldTypes.YesNo,
  },
  {
    title: FieldTypeDetails[FieldTypes.Date].title,
    subTitle: FieldTypeDetails[FieldTypes.Date].subTitle,
    key: FieldTypes.Date,
  },
  {
    title: FieldTypeDetails[FieldTypes.PhoneNumber].title,
    subTitle: FieldTypeDetails[FieldTypes.PhoneNumber].subTitle,
    key: FieldTypes.PhoneNumber,
  },
];
